import { HttpService } from '@/services/http.service';

export default {
    async store(comment) {
        return await HttpService.httpPost('/comment-likes/create', comment);
    },
}
